import { UiModal, UiToast, IconLevel, CoinLevel, Link } from 'components';

import get from 'lodash/get';

import { NickName, IdenNewUser } from 'widgets/ui/iden';
import { globalStore } from 'stores';
import { track, user } from 'lib';

import socketLib from 'widgets/lib/socket';
import giftLib from 'widgets/functions/gift/gift';
import animate from 'widgets/functions/animation/animate';
import live from '../live';
import { getRtcStore } from 'widgets/lib/rtc/store';

socketLib.socketEvent.once('socket.connected', () => {
  socketLib.sendMsg({ action: 'history.get' });
});

const handle = (socket) => {
  socket.on('user.payLevelUp', (msg, { room }) => {
    user.loadUserInfo();
  });
  socket.on('user.info', (msg, { room }) => {
    const { data_d: data } = msg;
    if (!data || data.nowRank || !data.finance) {
      return;
    }

    user.loadUserInfo();
    // MM.user.setUserInfo(data);
  });

  //
  // // 开播状态变更
  socket.on('room.live', (msg, { room, sofa }) => {
    const isLive = msg.data_d.live;
    if (isLive) {
      setTimeout(() => {
        room.update();
        //       sofa.reload()
        if (!room.isRoomOwner) {
          socketLib.sendMsg({ action: 'watch.start' });
        }
      }, 3000);
    } else {
      if (room.isRoomOwner) {
        const timespan = Date.now() - live.getLastHeartBeatTime();
        track.send({
          event: 'live',
          event_type: 'liveOff',
          desc: '直播间关播',
          content: `${timespan}`,
        });
        console.warn('直播间关播', timespan);
      }
      // UiToast.info('已关播');
      // socketLib.sendMsg({action: 'watch.end'})
      room.stopLive();
      getRtcStore().currentRtcInfo.updatePublishingStream(false);
    }
  });

  socket.on('room.star', (msg, { room }) => {
    room.setRoomInfo(msg.data_d);
  });
  socket.on('room.chat_limit', (msg, { room }) => {
    room.roomInfo.runInAction((self) => {
      self.chat_limit = msg.data_d.chat_limit;
    });
  });
  socket.on('kickout.room_owner', (msg, { room }) => {
    room.setKickOut(true);
  });

  socket.on('follow.notify0204', (msg, { room }, { messages }) => {
    let user = msg.data;
    messages.add({
      render() {
        return (
          <>
            {user.is_24_hr_new_user && <IdenNewUser />}
            <NickName user={user}></NickName>
            <span> 关注了 </span>
            <NickName user={room.starInfo}>{room.starInfo.nick_name}</NickName>
          </>
        );
      },
    });
  });

  socket.on('sys.notice', (msg, { room }, { messages }) => {
    const item = msg.data;
    messages.add({
      msgType: 'sysNotice',
      msg: item,
    });
  });
};

export default handle;
